import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import Icon from "../../utils/Icons"

export default function SocialLinks() {
  const { facebook, instagram, linkedin, whatsapp, github } = ExternalUrls
  return (
    <SocialUl>
      <SocialLi>
        <SocialLink href={github} target="_blank">
          <Icon name="github" />
        </SocialLink>
      </SocialLi>
      <SocialLi>
        <SocialLink href={linkedin} target="_blank">
          <Icon name="linkedin" />
        </SocialLink>
      </SocialLi>
      <SocialLi>
        <SocialLink href={whatsapp} target="_blank">
          <Icon name="whatsapp" />
        </SocialLink>
      </SocialLi>
      <SocialLi>
        <SocialLink href={facebook} target="_blank">
          <Icon name="facebook" />
        </SocialLink>
      </SocialLi>
      <SocialLi>
        <SocialLink href={instagram} target="_blank">
          <Icon name="instagram" />
        </SocialLink>
      </SocialLi>
    </SocialUl>
  )
}

export const ExternalUrls = {
  facebook: "https://www.facebook.com/headliner.mohamed",
  instagram: "https://www.instagram.com/maeid_kh",
  linkedin: "https://www.linkedin.com/in/mohamed-khobba-984727121/",
  github: "https://github.com/Meid-KH",
  whatsapp: `https://wa.me/212696818851?text=${encodeURI(
    "This is a auto-generated message from the website of your bro :)"
  )}`,
}

const SocialUl = styled.ul`
  margin: 0 -10px;
  display: flex;
`
const SocialLi = styled.li`
  margin: 0 10px;
`
const SocialLink = styled.a`
  display: block;
  width: 30px;
  transition: var(--transition);
  filter: grayscale(1);
  &:hover {
    filter: grayscale(0);
    transform: translateY(-2px);
  }
`
